import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { DeleteProjectForm } from '../forms';
import { Tracker } from '../Tracker';
import { ProjectNameWithStatus } from '../helpers/ProjectNameWithStatus';


export const ProjectsTable = ({ projects, showCompanyName = false }) => {
    const navigate = useNavigate();
    
    const handleOpenProject = (projectId) => {
        navigate(`/project/${projectId}`);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'N/A';
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    return (
        <div className="table-responsive">
        <table className="data-table projects-table">
            <thead>
                <tr>
                    <th className="col-id project-id-column hide-on-mobile">ID</th>
                    <th className="col-primary project-name-column">Name</th>
                    {showCompanyName && <th className="col-company project-company-column hide-on-mobile">Company</th>}
                    <th className="col-date project-date-column hide-on-mobile">Date Created</th>
                    <th className="col-stage project-stage-column hide-on-mobile">Order Progress</th>
                    <th className="col-actions--wide project-actions-column">Actions</th>
                </tr>
            </thead>
            <tbody>
                {projects.map((project, index) => (
                    <tr key={project.id || index}>
                        <td className="col-id project-id-column hide-on-mobile">{project.id || project.project_id || 'N/A'}</td>
                        <td className="col-primary project-name-column">
                            <ProjectNameWithStatus project={project} />
                        </td>
                        {showCompanyName && (
                            <td className="col-company project-company-column hide-on-mobile">{project.company_name || '-'}</td>
                        )}
                        <td className="col-date project-date-column hide-on-mobile">{formatDate(project.created_at)}</td>
                        <td className="col-stage project-stage-column hide-on-mobile">
                            <Tracker currentStage={project.current_stage} mini={true} />
                        </td>
                        <td className="col-actions--wide project-actions-column">
                            <div className="project-actions">
                                <button 
                                    onClick={() => handleOpenProject(project.id || project.project_id)} 
                                    className="btn btn-action btn-secondary"
                                    title="Open Project"
                                >
                                    <FontAwesomeIcon icon={faFolderOpen} /> Open
                                </button>
                                <span className="project-delete-action">
                                    <DeleteProjectForm project={project} />
                                </span>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        </div>
    )
}